/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { PaginationApi } from '../../features/pagination';

@Component({
  selector: 'gh-grid-paginator',
  template: require('./grid-paginator.component.html'),
  styles: [require('./grid-paginator.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridPaginatorComponent implements OnInit, OnDestroy {
  @Input() pagination: PaginationApi;

  from: number;
  to: number;

  sizes = [10, 20, 30, 40, 50, 100, 200]; // tslint:disable-line:no-magic-numbers

  private subscription: Subscription;

  get size(): number {
    return this.pagination.pageSize;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    this.updateBinding();
    this.subscription = this.pagination.updated$.subscribe(() => this.update());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isAvailable(): boolean {
    return this.pagination.total > 0;
  }

  needControl(): boolean {
    return this.pagination.total > this.pagination.pageSize;
  }

  onPageSizeChange(n: number): void {
    this.pagination.pageSize = n;
  }

  private update(): void {
    this.updateBinding();
    this.changeDetectorRef.markForCheck();
  }

  private updateBinding(): void {
    if (this.pagination.total >= 0) {
      this.from = this.pagination.pageSize * this.pagination.currentPage + 1;
      this.to = Math.min(this.pagination.pageSize * (this.pagination.currentPage + 1), this.pagination.total);
    }
  }
}
